import React from 'react';


const MaintenancePage = () => {
    return (
        <div className="bg-white">
            <div className='container mx-auto'>
                <div className="h-screen w-full">
                    <div className="grid grid-cols-2 h-full">
                        <div className="flex justify-center items-center h-full w-full">
                            <div>
                                <h2 className="text-7xl font-medium">We are tidying up!</h2>
                                <h6 className="text-lg font-medium pt-1">Sorry for the inconvenience</h6>
                                <div className="pt-6">
                                    <p>currently updating servers too improve service.</p>
                                    <p>Thank you for your patience!</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-center items-center h-full w-full">
                            <div>
                                <img className="h-full" src="/assets/under-maintenance.avif" alt="maintenance"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;